<template>
  <div>
    <div>
      <el-form
        ref="elForm"
        :model="elForm"
        size="medium"
        label-width="120px"
        label-position="right"
      >
        <el-row :gutter="0">
          <el-col :span="12">
            <el-form-item label="选中的地址：" prop="address">
              <el-input
                v-model="address"
                clearable
                :style="{ width: '100%' }"
                :disabled="true"
              >
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="选中经纬度：" prop="lat_long">
              <el-input
                v-model="lat_long"
                clearable
                :style="{ width: '100%' }"
                :disabled="true"
              >
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="4">
            <el-button type="primary" size="medium" @click="selectOk">确定</el-button>
            <!-- <el-button @click="$parent.$parent.selectAddressShow = false">关闭</el-button> -->
          </el-col>
        </el-row>
      </el-form>
    </div>
    <el-card shadow="never" body-style="padding: 0px 5px 5px 5px;">
        <div id="map-container" class="mapComponent" />
    </el-card>
  </div>
</template>

<script type="text/javascript">
  export default {
    name : "TdMap",
    components: {},
    data() {
      return {
        elForm : {},
        wxMap: null,
        address: null,
        lat_long: null
      };
    },
    props : ['currNode'],
    mounted() {
      if (this.currNode && this.currNode[0] && this.currNode[0].data) {
        this.address = this.currNode[0].data.extPath || ''
        this.lat_long = (this.currNode[0].data.longitude || '') + ',' + (this.currNode[0].data.latitude || '')
      }
      this.$nextTick(() => {
        this.initwxMap();
      })
    },
    activated(){
      console.log('currNode', this.currNode)
    },
    methods: {
      selectOk() {
        this.$emit('selectAddressOk', this.lat_long);
      },
      // 初始化天地图
      initwxMap() {
        // if(this.wxMap){
        //   this.wxMap.panTo(new T.LngLat(this.currNode[0].data.longitude, this.currNode[0].data.latitude))
        //   return;
        // }
        // vue项目需要先声明 T = window.T
        let T = window.T;
        this.wxMap = new T.Map('map-container'); // div的id
        // 传参中心点经纬度，以及放大程度，最小1，最大18
        const lng = this.currNode && this.currNode[0] && this.currNode[0].data ? (this.currNode[0].data.longitude || 116.397428) : 116.397428
        const lat = this.currNode && this.currNode[0] && this.currNode[0].data ? (this.currNode[0].data.latitude || 39.90923) : 39.90923
        this.wxMap.centerAndZoom(new T.LngLat(lng, lat), 9);
        var cp = new T.CoordinatePickup(this.wxMap, {
          callback: this.getLngLat
        });
        cp.addEvent();
        //鹰眼
        let miniMap = new T.Control.OverviewMap({
          isOpen: true,
          size: new T.Point(150, 150)
        });
        this.wxMap.addControl(miniMap);
        this.getLngLat(new T.LngLat(lng, lat));
      },
      getLngLat(lnglat) {
        let T = window.T;
        const x = lnglat.lng.toFixed(6);
        const y = lnglat.lat.toFixed(6);
        this.wxMap.clearOverLays(); // 清空原来的标注点
        let point = new T.LngLat(x, y);
        let marker = new T.Marker(point);
        this.wxMap.addOverLay(marker); // 添加标注点
        this.getGeocoderFun(x, y);
      },
      // 根据经纬度获取地址
      async getGeocoderFun(lon, lat) {
        let T = window.T;
        let geocoder = new T.Geocoder();
        geocoder.getLocation(new T.LngLat(lon, lat), (result) => {
          this.address = result.getAddress();
          this.lat_long = lon + ',' + lat;
        });
      }
    }
  };

</script>

<style scoped>
  .mapComponent {
    margin: 0px;
    padding: 0px;
    width: calc(100%);
    height: 50vh;
    z-index: 0;
  }
</style>



// WEBPACK FOOTER //
// src/views/market/components/TdMap.vue